import { ChangeEvent } from "react";
import { FormElement, FormInput } from "../../../components";
import { ValidationErrors } from "../../../ContactInfo.types";
import { CustomerName, CustomerNameKey } from "../EditNamePage.types";

type EditNameFormProps = {
  customer: CustomerName;
  changedFields: Set<CustomerNameKey>;
  validationErrors: ValidationErrors;
  pending: boolean;

  /** Callback when a field changes */
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
};

export const EditNameForm = ({
  customer,
  changedFields,
  validationErrors,
  pending,
  onChange,
}: EditNameFormProps) => {
  const { firstName, middleName, lastName } = customer;

  const getFieldError = (id: CustomerNameKey): string | undefined => {
    return changedFields.has(id) ? validationErrors[id] : undefined;
  };

  return (
    <>
      <FormElement<CustomerNameKey>
        id="firstName"
        label="First name"
        required
        showRequiredIndicator={false}
        error={getFieldError("firstName")}
      >
        <FormInput
          autoComplete="given-name"
          maxLength={40}
          onChange={onChange}
          value={firstName}
          readOnly={pending}
        />
      </FormElement>

      <FormElement<CustomerNameKey>
        id="middleName"
        label="Middle name"
        showOptionalIndicator
      >
        <FormInput
          autoComplete="additional-name"
          maxLength={40}
          onChange={onChange}
          value={middleName}
          readOnly={pending}
        />
      </FormElement>

      <FormElement<CustomerNameKey>
        id="lastName"
        label="Last name"
        required
        showRequiredIndicator={false}
        error={getFieldError("lastName")}
      >
        <FormInput
          autoComplete="family-name"
          maxLength={80}
          onChange={onChange}
          value={lastName}
          readOnly={pending}
        />
      </FormElement>

      {/* This only exists so the form can be submitted via the enter key. */}
      <input type="submit" value="Submit" style={{ display: "none" }} />
    </>
  );
};
